module.exports = __webpack_public_path__ + "static/img/5.df7d6be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/5.png
// module id = 9yAq
// module chunks = 0